import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { FullScreenLoader } from '@ui/components/FullScreenLoader';
import {
  SEND_SNAP_QUOTE_MUTATION_KEY,
  useSendSnapQuoteMutation,
} from '@ui/features/quote-builder/state/endpoints/send-snap-quote';
import React, { Suspense } from 'react';

import { useQuoteBuilderDialog } from '../../hooks/useQuoteBuilderDialog';

const PDFDialogContent = React.lazy(() => import('./PDFDialogContent'));

export function QuoteBuilderPDFDialog() {
  const { isOpen, close } = useQuoteBuilderDialog({ name: 'pdf' });
  const [_, { isLoading }] = useSendSnapQuoteMutation({
    fixedCacheKey: SEND_SNAP_QUOTE_MUTATION_KEY,
  });

  return (
    <Modal
      size="full"
      isOpen={isOpen}
      onClose={() => {
        if (!isLoading) {
          close();
        }
      }}
    >
      <ModalOverlay />
      <Suspense
        fallback={
          <ModalContent>
            <ModalBody>
              <FullScreenLoader />
            </ModalBody>
          </ModalContent>
        }
      >
        <PDFDialogContent />
      </Suspense>
    </Modal>
  );
}
